import { CompleteKundali } from '../types/kundali';
import { StoredKundaliRecord } from '../lib/kundaliService';

/**
 * Generates a normalized uniqueness key based strictly on DOB, Time, and POB (Place of Birth).
 */
export function getBirthDetailsKey(details: {
  date?: string;
  time?: string;
  placeName?: string;
  name?: string;
}): string {
  const d = (details.date || '').trim().toLowerCase();
  // Normalize time (e.g. 05:30 vs 5:30)
  const rawTime = (details.time || '').trim().toLowerCase().replace(/\s+/g, '');
  const timeParts = rawTime.split(':');
  const normalizedTime = timeParts.length === 2 
    ? `${timeParts[0].padStart(2, '0')}:${timeParts[1].padStart(2, '0')}`
    : rawTime;

  // Normalize place name (remove extra spaces and punctuation)
  const normalizedPlace = (details.placeName || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

  const normalizedName = (details.name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '');

  return `${normalizedName}__${d}__${normalizedTime}__${normalizedPlace}`;
}

/**
 * Deduplicate an array of CompleteKundali objects based on DOB, Time, and POB.
 */
export function deduplicateKundalis(kundalis: CompleteKundali[]): CompleteKundali[] {
  const seen = new Set<string>();
  const result: CompleteKundali[] = [];

  for (const k of kundalis) {
    if (!k || !k.birthDetails) continue;
    const key = getBirthDetailsKey(k.birthDetails);
    if (!seen.has(key)) {
      seen.add(key);
      result.push(k);
    }
  }

  return result;
}

/**
 * Deduplicate an array of StoredKundaliRecord objects based on DOB, Time, and POB.
 */
export function deduplicateStoredRecords(records: StoredKundaliRecord[]): StoredKundaliRecord[] {
  const seen = new Set<string>();
  const result: StoredKundaliRecord[] = [];

  for (const r of records) {
    if (!r) continue;
    const key = getBirthDetailsKey({
      date: r.date,
      time: r.time,
      placeName: r.placeName,
      name: r.name
    });
    if (!seen.has(key)) {
      seen.add(key);
      result.push(r);
    }
  }

  return result;
}
